export { getPhrasingContentSchema } from '@wordpress/dom';
export { pasteHandler } from './paste-handler';
export { rawHandler } from './index.js';
